import {ButtonProps} from "app/WebView/Toolbar/ToolbarView.model"
import React from "react"

function ToolbarIcon({button}: ButtonProps) {
  if (!button.icon) return null
  return (
    React.createElement(button.icon.icon, {
      ...button.icon.props,
      key: button.id,
      id: `toolbar-${button.id}`,
    })
  )
}

export default ToolbarIcon
